module.exports = __webpack_public_path__ + "img/mas.97c6020d.svg";